<template>
  <div class="animated fadeIn">
    <b-card v-if="!show">
      <div slot="header">Project / Location  
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add" >Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit" :disabled="(!(terpilih.customer_id))">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm" :disabled="(!(terpilih.customer_id))">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6" class="pr-5">
          <b-form-group label-cols=3 label="Project Name">
              <b-form-input v-model="tblData.name"></b-form-input>
          </b-form-group>
          <b-form-group label-cols=3 label="Project Code">
              <b-row>
                <b-col  cols="4"><b-form-input v-model="tblData.code" placeholder="Project Code"></b-form-input></b-col>
                <b-col  cols="8">
                    <b-form-group label-cols=3 label="Project Name">
                      <b-form-select v-model="tblData.name" :plain="true" :options="customerGroups" ></b-form-select>
                    </b-form-group>                          
                </b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
        <b-col lg="6">
          <b-form-group label-cols=3 label="Sales(AE) | Collector">
              <b-row>
                <b-col class="pr-1" cols="5"><b-form-input v-model="tblData.SalesCode" placeholder="Sales (AE)"></b-form-input></b-col>
                <b-col class="pl-1" cols="6"><b-form-input v-model="tblData.collector" placeholder="Collector"></b-form-input></b-col>
              </b-row>                      
          </b-form-group>
          <b-form-group label-cols=3 label="Contact Name">
              <b-row>
                <b-col class="pr-1" cols="7"><b-form-input v-model="tblData.contact" placeholder="contact name"></b-form-input></b-col>
                <b-col class="pl-1" cols="5">
                  <b-row>
                    <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                  </b-row>
                </b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover 
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked"
      >
        <template v-slot:cell(Address)="data">
          {{ data.item.Address1 }}
          {{ data.item.Address2 }}
        </template>
        <template v-slot:cell(PhoneNo)="data">
          <span v-if="(data.item.PhoneNo)">P.{{data.item.PhoneNo}}</span>&nbsp;
          <span v-if="(data.item.FaxNo)">F.{{data.item.FaxNo}}</span>
        </template>
        <template v-slot:cell(CreditLimit)="data">
          {{data.item.CreditLimit | numFormat}}
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
            <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-row class="justify-content-center" v-if="show">
      <b-col md="8" lg="7">
        <b-card>
          <div slot="header">Project/Location 
            <div class="card-header-actions">
              <b-button class="btn btn-primary mr-1" @click="handleCancel" > <i class="fa fa-close"></i> Close</b-button>
            </div>
          </div>
          <b-form ref="formAddRef"  @submit.prevent="handleSubmit" @reset="onReset" v-if="show">
              <b-row>
                <div class="col-4">
                  <b-form-group id="input-group-3" label="Project Code" label-for="customerCode-input">
                    <b-form-input id="customerCode-input" v-model="formAdd.customerCode" :state="$v.formAdd.customerCode.$dirty ? !$v.formAdd.customerCode.$error : null" type="text" required placeholder="Enter Code"></b-form-input>
                    <div v-if="$v.formAdd.customerCode.$error" class="invalid-feedback">
                        <span v-if="!$v.formAdd.customerCode.required">Project Code is required</span>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-8">
                  <b-form-group id="input-group-2" label="Project Name" label-for="name-input">
                    <b-form-input id="name-input" v-model="formAdd.name" :state="$v.formAdd.name.$dirty ? !$v.formAdd.name.$error : null" type="text" required placeholder="Enter full name"></b-form-input>
                    <div v-if="!$v.formAdd.name.required" class="invalid-feedback">Project Name is required</div>
                  </b-form-group>
                </div>
                <div class="col-12">
                  <b-form-group id="input-group-4" label="Address" label-for="address-input">
                    <b-form-textarea
                      id="address-input"
                      v-model="formAdd.address"
                      :state="$v.formAdd.address.$dirty ? !$v.formAdd.address.$error : null"
                      placeholder="Please enter address..."
                      rows="3"
                    ></b-form-textarea>
                    <div v-if="!$v.formAdd.address.required" class="invalid-feedback">Address is required</div>
                  </b-form-group>
                </div>
                <div class="col-6">
                  <b-form-group id="input-group-4" label="Postal Code" label-for="postal_code-input">
                    <b-form-input id="postal_code-input" v-model="formAdd.postal_code" :state="$v.formAdd.postal_code.$dirty ? !$v.formAdd.postal_code.$error : null" type="text" required placeholder="Enter Postal Code"></b-form-input>
                    <div v-if="!$v.formAdd.postal_code.required" class="invalid-feedback">Postal Code is required</div>
                  </b-form-group>
                </div>
                <div class="col-6">
                  <b-form-group id="input-group-4" label="City" label-for="city-input">
                    <b-form-input id="city-input" v-model="formAdd.city" :state="$v.formAdd.city.$dirty ? !$v.formAdd.city.$error : null" type="text" required placeholder="Enter City"></b-form-input>
                    <div v-if="!$v.formAdd.city.required" class="invalid-feedback">City is required</div>
                  </b-form-group>
                </div>
                <div class="col-6">
                  <b-form-group id="input-group-4" label="Province" label-for="province-input">
                    <b-form-input id="province-input" v-model="formAdd.province" :state="$v.formAdd.province.$dirty ? !$v.formAdd.province.$error : null" type="text" required placeholder="Enter Province"></b-form-input>
                    <div v-if="!$v.formAdd.province.required" class="invalid-feedback">Province is required</div>
                  </b-form-group>
                </div>
                <div class="col-6">
                  <b-form-group id="input-group-4" label="Phone Number" label-for="phone-input">
                    <b-form-input id="phone-input" v-model="formAdd.phone" :state="$v.formAdd.phone.$dirty ? !$v.formAdd.phone.$error : null" type="text" required placeholder="Enter Phone Number"></b-form-input>
                    <div v-if="!$v.formAdd.phone.required" class="invalid-feedback">Phone Number is required</div>
                  </b-form-group>
                </div>
              </b-row>
              <b-row>
                  <!-- <b-col md="6">
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-1">Periode Timesheet/ Proses Payroll</span></b-input-group-prepend>
                        <b-form-input  v-model="formAdd.batasTglTrx" type="number"></b-form-input>
                          <b-input-group-prepend><span class="input-group-text" >setiap bulan</span> </b-input-group-prepend>
                    </b-input-group>
                  </b-col> -->
                  <b-col md="5">
                    <b-input-group >
                        <b-input-group-prepend><label >Status Project</label></b-input-group-prepend>
                        <b-form-select id="status-input" v-model="formAdd.status" :options="statusOptions" :state="$v.formAdd.status.$dirty ? !$v.formAdd.status.$error : null">
                          <template v-slot:first>
                            <option :value="null">-- Select Status --</option>
                          </template>
                        </b-form-select>
                    </b-input-group>
                      <div v-if="!$v.formAdd.status.required" class="invalid-feedback">Status is required</div>
                  </b-col>
              </b-row>
          </b-form>
          <div slot="footer" style="text-align:center;">
            <button class="btn btn-primary mr-1" @click="handleOk">
              <i class="icon-check icons"></i> Save
            </button>
            <button class="btn btn-danger mr-1" @click="handleCancel" > <i class="icon-close icons"></i> Cancel</button>
          </div>
        </b-card>
      </b-col>
    </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss">
.list-of-customer {
  table {
    td:nth-child(1) {
      width: auto;
    }
    td:nth-child(2) {
      width: 120px;
    }
  }
}
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import customer from "../../apis/customers";
import { validationMixin } from 'vuelidate'
  import { required } from 'vuelidate/lib/validators'
import toastr from "mini-toastr";
toastr.init();

export default {
  components: {Loading},
    mixins: [validationMixin],
    validations: {
      formAdd: {
        customerCode: {
          required
        },
        name: {
          required
        },
        address: {
          required
        },
        postal_code: {
          required
        },
        city: {
          required
        },
        province: {
          required
        },
        phone: {
          required
        },
        status: {
          required
        }
      }
    },    
  data() {
    return {
      show: false,
      showDelConfirm: false,
      horizontal: true,
      showFilter:false,
      isLoading:false,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
      terpilih:{customer_id:''},
        formAdd: {
          customer_id: null,
          customerCode: null,
          name: null,
          address: null,
          phone: null,
          postal_code: null,
          city: null,
          province: null,
          status: 'active'
        },
        statusOptions: [{ value: 'active', text: 'Active' }, { value: 'inactive', text: 'Inactive' }],
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: null,
        sortDesc: false,
        customer_group: ''
      }
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "customerCode",
            thStyle: "width:150px",
            label: "Project Code",
            sortable: true
          },
          {
            key: "name",
            label: "Project Name",
            sortable: true
          },
          {
            key: "address",
            label: "Address",
          },
          {
            key: "city",
            label: "City",
            sortable: true
          },
          {
            key: "province",
            label: "Province",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "phone",
            label: "Phone/Fax",
          },
          {
            key: "status",
            label: "Status",
            thStyle: "width:50px",
            sortable: true
          },
        ];
      return fields;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await customer.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.name = '';
        this.tblData.code =  '';
        this.tblData.contact =  '';
        this.refresh();
    },
    add() {
        // console.log('clean form kepanggil')
        this.isEdit = false
        this.formAdd.customer_id = null
        this.formAdd.customerCode = null
        this.formAdd.name = null
        this.formAdd.address = null
        this.formAdd.phone = null
        // this.formAdd.report = null
        this.formAdd.postal_code = null
        this.formAdd.city = null
        this.formAdd.province = null
        this.show = true
      },  
      handleSubmit: async function () {
        // Check Vuelidate
        this.$v.formAdd.$touch()
        if (this.$v.formAdd.$anyError) {
          return
        }
        // put logic here
        // start data Customer List
        this.isLoading = true
        // hide modal
        // this.$refs.modalAdd.hide()
        this.show = false
        try {
          // start data customer report
          let data = {}
          data.customer_id = this.formAdd.customer_id
          data.customerCode = this.formAdd.customerCode
          data.name = this.formAdd.name
          data.address = this.formAdd.address
          data.phone = this.formAdd.phone
          data.postal_code = this.formAdd.postal_code
          data.city = this.formAdd.city
          data.province = this.formAdd.province
          data.modified_by = this.$store.state.user.username
          if (!this.isEdit) {
            data.created_by = this.$store.state.user.username
            // call api insert
            const hasil = await customers.insert(data)
            data.status = this.formAdd.status
            await customers.update(data)
          }
          this.onReset() // reset form
          this.refresh()
          this.isLoading = false
        } catch (error) {
          // console.log(toastr)
          if (error.message) {
            toastr.error(error.message)
          } else {
            toastr.error(JSON.stringify(error))
          }
          this.isLoading = false
        }
        // update lku customer
      },        
      handleOk (bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleCancel () {
        this.show = false
      },      
      edit(items) {
        if (items.customer_id) {
          this.isEdit = true
          this.formAdd = JSON.parse(JSON.stringify(items));
          this.show = true
        } else {
              toastr.warn('Please select a row that want to be Edit!');
        }
      },
      onReset () {
        // Reset our form values
        this.formAdd.customerCode = null
        this.formAdd.name = null
        this.formAdd.address = null
        this.formAdd.phone = null
        // this.formAdd.report = null
        this.formAdd.postal_code = null
        this.formAdd.city = null
        this.formAdd.province = null
        // Hide modal and reset form 
        // this.$refs.modalAdd.hide()
        this.show = false
        setTimeout(() => {
          this.$v.$reset();
        }, 500);
    },      
    deleteConfirm() {
      if (this.terpilih.customer_id) {
        this.showDelConfirm = true;
      } else {
            toastr.warn('Please select a row that want to be Deleted!');
      }
    },
    deleteData: async function() {
          try {
            await customer.remove(this.terpilih);
            this.refresh();
          } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'Error Info',10000);
                } else {
                    toastr.error(JSON.stringify(error),'Error Info',10000);
                }        
          }
    },
    rowClicked(record, index) {
        if ((this.terpilih) && (this.terpilih._rowVariant)) {
            delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
    },

    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await customer.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message, 'Error Info',10000);
            } else {
                toastr.error(JSON.stringify(error), 'Error Info',10000);
            }
        }
    },
    close(){
      router.push("/payroll/home");
    },    

  }
};
</script>
